import axios from "axios";
import { PROXY } from "./utils";

export const isCanceledAxiosRequest = (error) =>
  axios.isCancel(error) ||
  error?.code === "ERR_CANCELED" ||
  error?.name === "CanceledError" ||
  error?.config?.signal?.aborted === true;

export const isHelpApiRequest = (error) => {
  if (!error?.config?.url) return false;

  try {
    const requestUrl = new URL(axios.getUri(error.config), window.location.origin);
    const apiUrl = new URL(PROXY);
    const apiPath = apiUrl.pathname.replace(/\/+$/, "");

    return (
      requestUrl.origin === apiUrl.origin &&
      (requestUrl.pathname === apiPath ||
        requestUrl.pathname.startsWith(`${apiPath}/`))
    );
  } catch {
    return false;
  }
};
